export function getUser(id, usersArray) {
  const user = usersArray.find((user) => user.id === id);

  if (user) {
    return `${user.name} ${user.lastName}`;
  } else {
    return "Usuario no encontrado"; // O puedes manejar el caso en el que no se encuentra el usuario de alguna otra manera
  }
}
